window.SUB = window.SUB || {};

SUB.quizEngine = {
	start : function(){

		SUB.el = {
			window : window,
			html : $('html'),
			body : $('body'),
			quizWrapper: $('#quiz_wrapper'),
			header : $('header')
		};

	   // Quiz logic, from Tom Deater
		var qOrder = [ [0, 1, 2, 3, 4], [0, 1, 2, 3] ];

		var qCurrent = [0, 0];

		var userAnswers = [ [], [] ];

		var qSets = qOrder.length;

		var qSetCurrent = 0;

		var qSetComplete = [false, false];

		var question_template =  _.template( $( ".question_template" ).html());

		var $question_markup;

		var quiz = SUB.quiz = {
			init: function ($el, shuffle) {
				if (shuffle) {
					quiz.shuffleQuestions();
				}

				// init and render quiz in $el
				quiz.buildTemplate($el);

				quiz.destroy = function (str) {
					// redirect to new recipe page
					SUB.el.window.location = str;
				};
			},

			shuffleQuestions: function () {
				qOrder = _.map(qOrder, function (o) {
					return _.shuffle(o);
				});
				//console.log('shuffled qOrder', qOrder);

				// adjust the answer pattern strings to align with the new question order
				answers = _.map(SUB.data.answers, function (answer, i) {
					return _.map(answer, function (a) {
						var newAnswers = [];
						var oldAnswers = a.pattern.split('');
						_.each(qOrder[i], function (n) {
							newAnswers.push(oldAnswers[n]);
						});
						a.pattern = newAnswers.join('');
						return a;
					});
				});
				//console.log('adjusted answer pattern strings', answers);
			},

			buildTemplate: function ($el) {
				quiz.renderQuestion();
				$question_markup.appendTo($el).find('button').on('click', quiz.processAnswer);
			},

			renderQuestion: function () {
				var question = quiz.getCurrentQuestion();

				if (!question) {
					// we've reached the end of this qSet
					alert('no more questions');
					return;
				}
				var questionText = question.question.replace(/ /g, '-').replace('&nbsp;…', '').replace(',', '').replace(/’/g, '');
				dataLayer.push({event: 'pageview', url: 'action/question/' + questionText});

				$question_markup = $(question_template(question));
			},

			processAnswer: function (e) {
				e.preventDefault();

				userAnswers[qSetCurrent].push($(this).attr('data-answer'));
				var textAnswer = $(this).attr('data-answer-text').replace(/ /g, '_').replace(/’/g, '').replace(/,/g, '').replace('&nbsp;…', '').replace('?', '').replace('.', '').replace(/!/g, '');
				dataLayer.push({event: 'event', category: 'quiz_detail', action: 'thats_me', label: textAnswer});

				quiz.next();
			},

			getCurrentQuestion: function () {
				var qIndex = qOrder[qSetCurrent][qCurrent[qSetCurrent]];
				var question = SUB.data.questions[qSetCurrent][qIndex];

				if (!question) {
					// we've reached the end of this qSet
					qSetComplete[qSetCurrent] = true;
					//console.log('end of qset', qSetCurrent);
					// any more incomplete qSets?
					if (quiz.isRemainingQSet()) {
						// try the other qSet
						qSetCurrent = quiz.nextQSet();
						return quiz.getCurrentQuestion();
					} else {
						return;
					}
				} else {
					return question;
				}
			},

			next: function () {
				// get all matches for current qSet
				var matches = quiz.findMatches();
				//console.log('%s matches for "%s" in qSet %s:', matches.length, userAnswers[qSetCurrent].join(''), qSetCurrent);
				//console.table(matches);

				// exactly 1 match, or 0 remaining questions?
				if (matches.length === 1 || qCurrent[qSetCurrent] === qOrder[qSetCurrent].length - 1) {
					// this qSet is finished, mark it complete
					qSetComplete[qSetCurrent] = true;
					//console.log('marking qSet %s complete', qSetCurrent);
				} else {
					// "look ahead" to prune invalid paths from this qSet before proceeding
					qCurrent[qSetCurrent] = quiz.lookAhead();

					if (!qCurrent[qSetCurrent]) {
						// no more valid paths in this qSet
						qSetComplete[qSetCurrent] = true;
						//console.log('no more valid paths for qSet %s', qSetCurrent);
						//console.log('marking qSet %s complete', qSetCurrent);
					}
				}

				// switch qSets?
				if (quiz.isRemainingQSet()) {
					qSetCurrent = quiz.nextQSet();
					quiz.buildTemplate(SUB.el.quizWrapper);
					SUB.advanceSlides();
				} else {
					// all qSets are complete
					quiz.exit();
				}
			},

			nextQSet: function (n) {
				var nextSet;
				n = (typeof n !== 'undefined') ? n : qSetCurrent;
				nextSet = (n < qSets - 1) ? n + 1 : 0;
				if (qSetComplete[nextSet]) {
					return quiz.nextQSet(nextSet);
				} else {
					return nextSet;
				}
			},

			isRemainingQSet: function () {
				return !!_.without(qSetComplete, true).length;
			},

			lookAhead: function () {
				var reA, reB, matchesA, matchesB;

				reA = new RegExp('^' + userAnswers[qSetCurrent].join('') + 'a');
				reB = new RegExp('^' + userAnswers[qSetCurrent].join('') + 'b');

				matchesA = quiz.findMatches(reA);
				matchesB = quiz.findMatches(reB);

				//console.log('%s lookahead matches for "' + userAnswers[qSetCurrent].join('') + ' + a" in qSet %s', matchesA.length, qSetCurrent);
				//if (matchesA.length) console.table(matchesA);
				//console.log('%s lookahead matches for "' + userAnswers[qSetCurrent].join('') + ' + b" in qSet %s', matchesB.length, qSetCurrent);
				//if (matchesB.length) console.table(matchesB);


				if (matchesA.length && matchesB.length) {
					// both paths are valid, proceed to next question
					return qCurrent[qSetCurrent] + 1;
				} else if (matchesA.length) {
					// only answer A provides a valid path
					// choose 'a' and recurse
					userAnswers[qSetCurrent].push('a');
					qCurrent[qSetCurrent]++;
					//console.log('+a (skipping question "%s")', quiz.getCurrentQuestion().question);
					return quiz.lookAhead();
				} else if (matchesB.length) {
					// only answer B provides a valid path
					// choose 'b' and recurse
					userAnswers[qSetCurrent].push('b');
					qCurrent[qSetCurrent]++;
					//console.log('+b (skipping question "%s")', quiz.getCurrentQuestion().question);
					return quiz.lookAhead();
				} else {
					// no more valid paths, stop asking questions
					return 0;
				}
			},

			findMatches: function (re) {
				var re = re || new RegExp('^' + userAnswers[qSetCurrent].join(''));
				var matches = _.filter(SUB.data.answers[qSetCurrent], function (answer) {
					if (re.test(answer.pattern)) {
						return answer;
					}
				});
				return matches;
			},

			exit: function () {
				var matches = [], winner, result = [];
				// get all matches for all qSets and display/exit
				_.each(qSetComplete, function (b, i) {
					qSetCurrent = i;
					matches.push(quiz.findMatches());
				});

				//console.log('valid answers');

				_.each(matches, function(match) {
					winner = Math.floor(Math.random() * match.length);
					result.push(match[winner].name);
					//console.table(match);
				});

				quiz.destroy('recipes/'+ result.join('?td=0&profile='));

			}
		};

		// start Quiz
		quiz.init(SUB.el.quizWrapper, true);

		// if mobile, also fire on orientation change
		window.addEventListener('orientationchange', function(){
			$('.question_img').each(
				function(){SUB.imgLoaded(this)}
			)
		});

		// set "Let's do this" button behavior
		$('#letsdothis').click(function(e){
			e.preventDefault();
			dataLayer.push({event: 'event', category: 'quiz', action: 'quiz_start', label: 'quiz_lets_do_this_click'});
			SUB.advanceSlides();
		});
	}
};

// scrolling between slides
SUB.advanceSlides = function(){
	var $sections = SUB.el.quizWrapper.find('section'),
		sectionCount = $sections.length,
		$collapseSection = ($sections.first()),
		sectionMove = $collapseSection.outerHeight() * -1;

	TweenMax.to($collapseSection, 1, {marginTop:sectionMove, ease: Circ.easeInOut, onComplete:function(){
		// collapse and delete sections above, creating scroll effect
		$collapseSection.remove();
	}});
};

SUB.imgLoaded = function(img){
	var $img = $(img),
		$parent = $img.parent();

	// when image loads in, replace parent's bg image source with newly-loaded image.
	// keep opaque image in place to set height of container

	$parent.css('background-image', 'url(' + $img.attr('src') + ')');

};

